import { Routes, Route, Navigate } from "react-router-dom"

import Login from "./Login"
import Verify from "./Verify"


function Auth(props) {
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route path="verify" element={<Verify />} />
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
    )
}

export default Auth
